import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IChangeForgotPasswordDto } from './models/change-forgot-password-dto';
import { SERVICES_API } from '@pro-connect/shared';

@Injectable({
  providedIn: 'root',
})
export class ChangeForgotPasswordService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Change client password by token.
   * @param changeForgotPasswordDto
   * @param recaptchaKey
   * @param token
   */
  public changeForgotPassword(
    changeForgotPasswordDto: IChangeForgotPasswordDto,
    recaptchaKey: string,
    token: string,
  ): Observable<unknown> {
    return this._httpClient.post<unknown>(
      `${this._servicesApi}/pro/remind-password/${token}/change-password`,
      changeForgotPasswordDto,
      {
        params: {
          recaptchaKey,
        },
      },
    );
  }
}
